<script setup lang="ts">
  import { computed } from 'vue';
  import { resolveImageSource } from '@record-fill';
  import type { FormElement, ImageProperties } from '../../../model';
  import { useElementContainerStyles } from '../../../model';
  import { useImageDisplay } from '../../../model/useImageDisplay';

  interface Props {
    element: FormElement & { properties: ImageProperties };
  }

  const props = defineProps<Props>();

  const { containerStyles } = useElementContainerStyles(computed(() => props.element.properties));

  const { displayUrl, handleImageError } = useImageDisplay(() => resolveImageSource(props.element.properties));
</script>

<template>
  <div
    class="image-element"
    :style="containerStyles"
  >
    <div
      v-if="displayUrl"
      class="image-display"
    >
      <img
        :src="displayUrl"
        alt="Logo"
        class="image-preview"
        @error="handleImageError"
      >
    </div>
  </div>
</template>

<style scoped>
  .image-element {
    font-family: var(--font-base);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .image-display {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .image-preview {
    max-width: 100%;
    max-height: 100px;
    object-fit: contain;
  }
</style>
